import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export function PlayIcon({ color, ...svgProps }: Props) {
  return (
    <SVG
      ref={svgProps.ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 24)}
      strokeWidth="2"
      {...svgProps}
      fill={color ?? svgProps.fill ?? "currentColor"}
      stroke={svgProps.stroke ?? "none"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2.338 3.255v17.49a1.5 1.5 0 002.209 1.322l16.323-8.745a1.5 1.5 0 000-2.644L4.547 1.933a1.5 1.5 0 00-2.209 1.322z" />
    </SVG>
  );
}
